import React, { useState } from "react";
import Modal from "../../Components/Base/Modal";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export default function ModalFollowers({
  setSelectedFollowersCount,
  close,
  handleSearch,
  selectedFollowersCount,
}) {
  const [minValue] = useState(0);
  const [maxValue] = useState(1000000);
  const [selMinValue, setSelMinValue] = useState(
    selectedFollowersCount.length > 0 ? selectedFollowersCount[0] : minValue
  );
  const [selMaxValue, setSelMaxValue] = useState(
    selectedFollowersCount.length > 0 ? selectedFollowersCount[1] : maxValue
  );
  const [minInput, setMinInput] = useState(
    (selectedFollowersCount.length > 0 ? selectedFollowersCount[0] : minValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
  const [maxInput, setMaxInput] = useState(
    (selectedFollowersCount.length > 0 ? selectedFollowersCount[1] : maxValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );

  const OnChangeEventTriggerd = (newValue) => {
    setSelMinValue(newValue[0]);
    setSelMaxValue(newValue[1]);
    setMinInput(newValue[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
    setMaxInput(newValue[1].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (newValue[1] === 1000000 ? "+" : ""));
  };

  const handleMinChange = (e) => {
    setMinInput(e.target.value);
  };

  const handleMinBlur = () => {
    const val = parseInt(minInput.replace(/,/g, "")) || 0;
    const clamped = Math.max(minValue, Math.min(val, selMaxValue));
    setSelMinValue(clamped);
    setMinInput(clamped.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  };

  const handleMaxChange = (e) => {
    setMaxInput(e.target.value);
  };

  const handleMaxBlur = () => {
    const val = parseInt(maxInput.replace(/[,+]/g, "")) || 0;
    const clamped = Math.min(maxValue, Math.max(val, selMinValue));
    setSelMaxValue(clamped);
    setMaxInput(clamped.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (clamped === 1000000 ? "+" : ""));
  };

  const saveFollowersCount = () => {
    setSelectedFollowersCount([selMinValue, selMaxValue]);
  };

  return (
    <Modal addClass="modalCamp" close={close} className="right-20">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-auto p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h4 className="text-lg font-semibold text-gray-900">Followers</h4>
       
        </div>

        {/* Input Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Min Followers</label>
            <input
              value={minInput}
              onChange={handleMinChange}
              onBlur={handleMinBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Max Followers</label>
            <input
              value={maxInput}
              onChange={handleMaxChange}
              onBlur={handleMaxBlur}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors"
            />
          </div>
        </div>

        {/* Slider */}
        <div className="mb-8 px-1">
          <div className="mb-2 flex justify-between text-xs text-gray-500">
            <span>0</span>
            <span>1M+</span>
          </div>
          <Slider
            range
            min={minValue}
            max={maxValue}
            value={[selMinValue, selMaxValue]}
            onChange={OnChangeEventTriggerd}
            trackStyle={[{ backgroundColor: '#16A34A', height: '4px' }]}
            handleStyle={[
              {
                borderColor: '#16A34A',
                backgroundColor: 'white',
                borderWidth: '2px',
                width: '20px',
                height: '20px',
                marginTop: '-8px'
              },
              {
                borderColor: '#16A34A',
                backgroundColor: 'white',
                borderWidth: '2px',
                width: '20px',
                height: '20px',
                marginTop: '-8px'
              }
            ]}
            railStyle={{ backgroundColor: '#e5e7eb', height: '4px' }}
          />
        </div>

        {/* Action Button */}
        <div className="flex justify-end">
          <button
            className="px-4 py-2 bg-green-600 text-white font-semibold rounded-lg hover:bg-green-700 focus:ring-2 focus:ring-blue-300 transition-colors"
            onClick={() => {
              saveFollowersCount();
              handleSearch();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
}